module.exports = __webpack_public_path__ + "static/media/berart.9513afd0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/berart.webp
// module id = 628
// module chunks = 0